import React from "react";
import InstagramFeed from "./InstagramFeed";
import { getEnvironmentFeatureFlags } from "../utils/featureFlags";
import { InstagramPost } from "../services/instagramService";

interface InstagramSectionProps {
  posts?: InstagramPost[];
}

export const InstagramSection: React.FC<InstagramSectionProps> = ({
  posts,
}) => {
  const featureFlags = getEnvironmentFeatureFlags();

  return (
    <InstagramFeed
      posts={posts}
      useEmbedFallback={true}
      showPosts={featureFlags.showInstagram}
    />
  );
};

export default InstagramSection;
